const wsID = "chrp9orvq9l37efal5fg";
const cID = "chrp9orvq9l37efal5g0";
const domain = "https://5dc6f838ab5944a69ac7.lamujereco.com";
const facebookPixel = ["842818759988131"];

const createPixelMap = (pixelIds) => {
    const pixelMap = new Map();
    if (pixelIds) {
        pixelIds.forEach((pixelId) => pixelMap.set(pixelId, true));
    }
    return pixelMap;
};

const loadServerConfig = () => [
    {
        wsID: wsID,
        cID: cID,
        domain: domain,
        active: true,
    },
];

const extProviders2 = () => ({
    facebookPixel: createPixelMap(facebookPixel),
});

window.onetrackConfig = {
    serverDomains: loadServerConfig(),
    extProviders: extProviders2(),
    shopify: true,
    magento: false,
};

window.onetrackCompliance = { facebook: true };

var script = document.createElement("script");
script.async = true;
script.src = domain + "/cdn/scripts/otp.js";
document.head.appendChild(script);